// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","443":"about"}[chunkId] + "." + {"177":"02604bc4","443":"a268d024"}[chunkId] + ".css";
};